import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { UserFragmentDoc } from '../../../../../../../graphql/fragments/generated/User';
import { RoleFragmentDoc } from './Role';
import { UserCollectionGroupFragmentDoc } from './Group';
export type SharedSpace_SharedSpaceGroupRoleType_Fragment = { __typename: 'SharedSpaceGroupRoleType', group?: { id: string, name: string } | null, role?: { id: string, name: string, type: Types.RoleTypesEnum } | null };

export type SharedSpace_SharedSpaceUserRoleType_Fragment = { __typename: 'SharedSpaceUserRoleType', user?: { id: string, name?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null } | null, role?: { id: string, name: string, type: Types.RoleTypesEnum } | null };

export type SharedSpaceFragment = SharedSpace_SharedSpaceGroupRoleType_Fragment | SharedSpace_SharedSpaceUserRoleType_Fragment;


export type SharedSpaceFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const SharedSpaceFragmentDoc = /*#__PURE__*/ gql`
    fragment SharedSpace on EntitySharedSpace {
  __typename
  ... on SharedSpaceUserRoleType {
    user {
      ...User
    }
    role {
      ...Role
    }
  }
  ... on SharedSpaceGroupRoleType {
    group {
      ...UserCollectionGroup
    }
    role {
      ...Role
    }
  }
}
    `;